<div class="cost-plan-header flex flex-col">
    <div class="flex gap-[8px]">
        <img class="item" src="../../../assets/images/chevron-left.svg" />
        <div tabindex="{0}" role="button" (click)="returnHomePage()" class="header-button">Back to Homepage</div>
    </div>
    <div class="header-container flex flex-col">
        <div class="header-title">Cost Plan</div>
        <div class="header-content">The cost plan is determined by the size of the team and the specific roles required. Tell us your requirements, and we’ll respond to you as soon as possible.</div>
    </div>
</div>
